import { aiRoutes } from "@/pages/ai/routes";
import { calendarRoutes } from "@/pages/calendar/routes";
import { homeRoutes } from "@/pages/home/routes";
import { managementRoutes } from "@/pages/management/routes";
import { performanceRoutes } from "@/pages/performance/routes";
import { salesRoutes } from "@/pages/sales/routes";
import { testingRoutes } from "@/pages/testing/routes";
import type { NavigationRoute } from "@/types/navigation-route";

export const appRoutes: NavigationRoute[] = [
    ...homeRoutes,
    ...salesRoutes,
    ...performanceRoutes,
    ...managementRoutes,
    ...calendarRoutes,
    ...aiRoutes,
    ...testingRoutes,
];
